import { api } from './api.service';
import {
  ICreateMedicalRecordPayload,
  IMedicalRecord,
  IMedicalRecordPaginated,
  IUpdateMedicalRecordPayload,
} from '../interfaces/IMedicalRecord';

export async function createMedicalRecord(
  payload: ICreateMedicalRecordPayload,
): Promise<IMedicalRecord> {
  const { data } = await api.post('/medical-records', payload);
  return data;
}

export async function getMedicalRecord(id: string): Promise<IMedicalRecord> {
  const { data } = await api.get(`/medical-records/${id}`);
  return data;
}

export async function updateMedicalRecord(
  id: string,
  payload: IUpdateMedicalRecordPayload,
): Promise<IMedicalRecord> {
  const { data } = await api.put(`/medical-records/${id}`, payload);
  return data;
}

export async function deleteMedicalRecord(id: string): Promise<void> {
  await api.delete(`/medical-records/${id}`);
}

export async function listMyMedicalRecords(
  params?: { page?: number; limit?: number; from?: string; to?: string },
): Promise<IMedicalRecordPaginated> {
  const { data } = await api.get('/medical-records/mine', { params });
  return data;
}

export async function listPatientMedicalRecords(
  patientId: string,
  params?: { page?: number; limit?: number; from?: string; to?: string; appointmentId?: string },
): Promise<IMedicalRecordPaginated> {
  const { data } = await api.get(`/patients/${patientId}/medical-records`, { params });
  return data;
}

export async function findRecordIdForAppointment(
  patientId: string,
  appointmentId: string,
): Promise<string | null> {
  try {
    const result = await listPatientMedicalRecords(patientId, { appointmentId, limit: 1 });
    return result.data[0]?.id ?? null;
  } catch {
    return null;
  }
}

export async function getPatientMedicalHistory(patientId: string): Promise<{
  patient: { id: string; name: string };
  total: number;
  records: IMedicalRecord[];
}> {
  const { data } = await api.get(`/patients/${patientId}/medical-history`);
  return data;
}
